import React, { useState, useRef, useEffect, memo, useContext } from "react";
import { Formik, Form, Field } from "formik";
import { useParams, useNavigate, Link } from "react-router-dom";
import { TagsInput } from "react-tag-input-component";
import * as Yup from "yup";
import Select from "react-select";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import { IoMdAddCircle } from "react-icons/io";
import { Modal } from "react-bootstrap";
import axios from "axios";
import config from "../../../../config/config";
import { uploadAWS } from "../../../../common/AWSHelper";
import { AppContext } from "../../../../context/AppContext";
import {ERROR_MESSAGE,SUCCESS_MESSAGE,ERROR_EXISTS,ALREADY_EXIST,AWS_IMAGE_FOLDER_CATEGORIES} from "../../../../common/Constant";
import Loader from "../../../../components/Loader/Loader";
import FileInput from "../../../../components/FormControls/FileInput";
import { toastError, toastSuccess } from "../../../../common/Toast";
import AttributesTableRows from "./ItemAttibutetableRow";
import ItemVariactionTableRows from "./ItemVariactionRows";
import { checkUserPermission } from "../../../../common/UserPermission";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const ItemInfo = (props) => {
  const buttonRef = React.useRef(null);
  const navigate = useNavigate();
  const selectRef = useRef(null);
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const paramObject = useParams();
  const [setChangeImagename] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedParentCategory, setselectedParentCategory] = useState(0);
  const [selectedCategory, setselectedCategory] = useState(0);
  const [ImageUrl, setImageUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [data, setData] = useState([]);
  const [SecondCategories, setSecondCategories] = useState([]);
  const [locationsData, setLocationsData] = useState([]); //store loaction from api response
  const [manufacturedropdwonData, setManufactureDropdwon] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [suppliers, setsuppliers] = useState([]);
  const [category, setCategory] = useState([{ ID: 0, CategoryId: "" }]);
  const [supplier, setSupplier] = useState([{ ID: 0, SupplierId: "" }]);
  const [show, setShow] = useState(false); //Show the Categories model
  const [showAddBrand, setShowAddBrand] = useState(false);
  const [Attributemodel, setAttributemodel] = useState(false); // Show The Attribute Model
  const [Modifiers, setModifiers] = useState([]);
  const [check, setCheck] = useState([]);
  const [quantity, setQuantity] = useState([]);

  // tags-
  const [selectedtags, setSelectedtags] = useState("");
  const [formValuesfortagmodel, setFormValuesforTagmodel] = useState({
    ID: 0,
    Tags: "",
  });
  const [showtag, setShowTag] = useState(false);
  const [tagsdropdwonData, setTagsdropdwonData] = useState([]);

  // manufacturers-
  const [showManufacture, setShowManufacture] = useState(false);
  const [formValuesformenufacturemodel, setFormValuesforMenufacturemodel] =
    useState({ ID: 0, Manufacture: "" });
  const [selectmanufacturedropdwonData, setselectmanufacturedropdwonData] =
    useState(0);

  const [Variationlist, setVariationlist] = useState([]);
  const [x, setX] = useState();
  const [WeightUnit, setWeightUnit] = useState(0);
  const [itemattributes, setItemAttributes] = useState("");
  const [options, setOptions] = useState([]);
  const [Attributedrop, setAttributedrop] = useState(false);
  const [SelectedAttributedrop, setSelectedAttributedrop] = useState([]);
  const [SelectedAttributelabledrop, setSelectedAttributelabeldrop] = useState(
    []
  );
  const [SelectedAttributeIddrop, setSelectedAttributeIddrop] = useState([]);
  const [SelectedAttributelablecommadrop, setSelectedAttributelablecommadrop] =
    useState([]);
  const [ItemFieldshow, setItemFieldshow] = useState(false);
  const [itemattribute, setItemAttribute] = useState([]); // Items Attributes Values Rows
  const [Itemvariations, setItemvariations] = useState([]); // Itemvariation Values Rows
  const [SubmitEvent, setSubmitEvent] = useState(0);

  const [globalAttribute, setGlobalAttribute] = useState();
  const [attributeName, setAttributeName] = useState();
  const [attributeValue, setAttributeValue] = useState();
  const [item, setItem] = useState([{ ID: 0, ItemNumbers: "" }]);
  const [selectMultipleSupplierFlag, setSelectMultipleSupplierFlag] =
    useState(false);

  // For Error
  const [nameError, setNameError] = useState("");
  const [error, setError] = useState({
    brandError: "",
    tagError: "",
    manufactureError: "",
  });
  const [attributeError, setAttributeError] = useState("");
  const [formValues, setFormValues] = useState({
    ItemName: "",
    BarcodeName: "",
    UpcName: "",
    ProductId: "",
    Tags: "",
    Description: "",
    LongDescription: "",
    ImPOP: "",
    Weight: parseFloat(0.0).toFixed(2),
    WeightUnit: "",
    DimensionsLength: parseFloat(0.0).toFixed(2),
    DimensionsWidth: parseFloat(0.0).toFixed(2),
    DimensionsHeight: parseFloat(0.0).toFixed(2),
    DefaultQuantity: parseFloat(0.0).toFixed(2),
  });

  // handleChangeforitems-
  const handleChangeforitems = (index, event) => {
    let name, values;
    name = event.target.name;
    values = event.target.value;

    const cardInput = [...item];
    cardInput[index][name] = values;
    setItem(cardInput);
  };

  // for close and open tags, manufacturers-
  const handeltagmodelClose = () => setShowTag(false);
  const handeltagmodelShow = () => setShowTag(true);
  const handleManufactureClose = () => setShowManufacture(false);
  const handleManufactureShow = () => setShowManufacture(true);
  // ---------------------------------------------

  let PERMISSION_ADD = "add-brand";

  //Additional Item Numbers Row Delete
  const deleteForAdditionalTableRows = (index) => {
    const rows = [...item];
    rows.splice(index, 1);
    setItem(rows);
  };

  // ADD item-
  const addItem = () => {
    const rowsInput = {
      ID: 0,
      ItemNumbers: "",
    };
    setItem([...item, rowsInput]);
  };

  // item number array-
  let ItemsNumbersArray = item.map((item) => item.ItemNumbers);

  // for App Context-
  const {
    valueStringFunction,
    deleteTableRowsFunction,
    fetchBrandFunction,
    fetchItemVariation,
    autoGenerationFunction,
  } = useContext(AppContext);

  const ActionButtons = (props) => {};
  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };

  // Create and Update Prime Supplier-
  const [primeSupplier, setPrimeSupplier] = useState({
    label: "",
    value: "",
  });
  const handleChangePrimeSupplier = (e) => {
    setPrimeSupplier({ label: e.label, value: e.value });
  };

  // Crete and Update Brand-
  const [addBrand, setAddBrand] = useState("");
  const handleAddBrand = (eventObject) => {
    eventObject.preventDefault();

    if (addBrand === "") {
      return setError({ ...error, brandError: "Please Fill Brand" });
    }

    if (addBrand !== "") {
      setLoading(true);
      axios
        .post(
          `${config.brandBaseUrl}/brands/upsert`,
          {
            id: 0,
            isactive: 1,
            name: addBrand,
            loginuserid: loginUserId,
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            toastSuccess(SUCCESS_MESSAGE);
            setShowAddBrand(false);
            fetchBrandFunction(SUCCESS_MESSAGE);
            setLoading(false);
            setError({ ...error, brandError: "" });
            setAddBrand("");
            // window.location.reload();
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            toastError(ERROR_EXISTS);
            setShowAddBrand(false);
            setLoading(false);
            setAddBrand("");
          } else {
            toastError(ERROR_MESSAGE);
            setLoading(false);
            setLoading(false);
            setAddBrand("");
          }
        });
    }
  };

  // -----------------------tags----------------------
  let TagsList = [];
  tagsdropdwonData?.map((u, i) => {
    TagsList[i] = { label: u.Name, value: u.ID };
  });

  const handleTagsDropdowns = (seletedId) => {
    // tags dropdown values
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTagsdropdwonData(res.data.ResponseData);

        return res;
      });
  };

  const handleSelectedtags = (e) => {
    const selectedTagValues = (Array.isArray(e) ? e.map((x) => x.value) : [])
      .join(",")
      .trim();
    setSelectedtags(selectedTagValues);
  };
  console.log("handleSelectedtags 266", selectedtags);

  // handleSubmit for tags model
  const handleSubmitformodeltags = async (eventObject) => {
    if (!eventObject.Tags) {
      return setError({ ...error, tagError: "Please Fill Tag" });
    }
    setLoading(true);
    axios
      .post(
        `${config.tagBaseUrl}/tags/upsert`,
        {
          id: 0,
          ecommerecetagid: 1,
          name: eventObject.Tags,
          tagtype: "Portal",
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          handleTagsDropdowns();
          setSelectedtags([...selectedtags, res.data.ResponseID]);
          setselectmanufacturedropdwonData(selectmanufacturedropdwonData);
          const clearData = {
            ID: 0,
            Tags: "",
          };
          let fixvalues = formValues;
          setFormValues(fixvalues);
          setFormValuesforTagmodel(clearData);
          setError({ ...error, tagError: "" });
          setShowTag(false);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setFormValuesforTagmodel({
            ID: 0,
            Tags: "",
          });
          setError({ ...error, tagError: "" });
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setFormValuesforTagmodel({
            ID: 0,
            Tags: "",
          });
          setError({ ...error, tagError: "" });
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setShowTag(false);
      });
  };

  // ---------------------manufacturers-------------------
  const handleDropdowns = (selectedIds) => {
    // supplier dropdown
    axios
      .get(`${config.suppliersBaseUrl}/suppliers/dropdownsupplier`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setsuppliers(res.data.ResponseData);
        return res;
      });

    // manufacture dropdon values
    axios
      .get(
        `${config.manufacturerBaseUrl}/manufacturers/manufacturersdropdown`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setManufactureDropdwon(res.data.ResponseData);
        if (selectedIds != undefined) {
          // Binding Category data
          let CategorieList = res.data.ResponseData;
          CategorieList.map((selectedManufacture) => {
            if (selectedManufacture.ID == selectedIds) {
              setselectmanufacturedropdwonData({
                label: selectedManufacture.Name,
                value: selectedManufacture.ID,
              });
            }
          });
        }
        // setLoading(false);
        return res;
      });
  };

  useEffect(() => {
    handleDropdowns();
  }, [props]);

  const handleSubmitformodelManufacture = async (eventObject) => {
    if (!eventObject.Manufacture) {
      return setError({
        ...error,
        manufactureError: "Please Fill Manufacturer",
      });
    }

    setLoading(true);
    axios
      .post(
        `${config.manufacturerBaseUrl}/manufacturers/upsert`,
        {
          id: 0,
          isactive: 1,
          name: eventObject.Manufacture,
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          const clearData = {
            ID: 0,
            Manufacture: "",
          };
          let fixvalues = formValues;
          setFormValues(fixvalues);
          handleDropdowns();
          setSelectedtags(selectedtags);
          handleDropdowns(res.data.ResponseID);
          setFormValuesforMenufacturemodel(clearData);
          handleManufactureClose();
          setError({ ...error, manufactureError: "" });
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setError({ ...error, manufactureError: "" });
          setFormValuesforMenufacturemodel({
            ID: 0,
            Manufacture: "",
          });
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setError({ ...error, manufactureError: "" });
          setFormValuesforMenufacturemodel({
            ID: 0,
            Manufacture: "",
          });
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTagsdropdwonData(res.data.ResponseData);
        setLoading(false);
        return res;
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const handleSubmitForm = () => {
    setSubmitEvent(1);
  };
  const handleNext = () => {
    props.nextStep();
    window.scrollTo(0, 0);
  };

  // let rows;
  const deleteTableRows = async (index) => {
    setLoading(true);
    axios
      .post(
        `${config.itemsBaseUrl}/items/itemattributedelete`,
        {
          id: itemattribute[index].ID,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          let rows = [...itemattribute];
          rows = rows.filter((obj) => obj.ID === index);
          setItemAttribute(rows);
          deleteTableRowsFunction(rows);
          setLoading(false);
          setAttributedrop(true);
          if (Attributedrop === true) {
            setAttributedrop(true);
          } else {
            setAttributedrop(false);
          }
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((err) => {});
  };
  const validationSchema = Yup.object().shape({
    ItemName: Yup.string().required("Name is required"),
  });

  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "0px",
      position: "relative",
    }), // dropdown input css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      position: "absolute",
      background: "#f8f8f8",
      width: "100%",
      zIndex: 99,
      // border: "solid orange",
    }),
    valueContainer: () => ({
      // padding: "0px 6px !importan",
      height: "0px !important",
      display: "contents",
    }),
  };

  // HANDLEFOR DROPDOWN CHNAGES BUTTONS FOR ADD ATTRIBUTES
  const handledrop = (e) => {
    if (e.target.value === "NewCustomAttribute") {
      setAttributedrop(true);
    } else {
      const selectedIndex = e.target.selectedIndex;
      const selectedOption = e.target.options[selectedIndex];
      const selectedValues2 = selectedOption.getAttribute("values2"); // for attribiutes commasepredvalue get
      const label = selectedOption.label; // get attribute name
      const Values = selectedOption.value;
      setSelectedAttributedrop(selectedValues2);
      setSelectedAttributeIddrop(Values);
      setSelectedAttributelabeldrop(label);
      setAttributedrop(false);
    }
  };

  const addNewQuantity = () => {
    setQuantity([
      ...quantity,
      {
        QuantityId: 0,
        Quantityname: "",
        Quantityunit: parseFloat(0.0).toFixed(2),
        Quantitysellingprice: parseFloat(0.0).toFixed(2),
        Quantitycostprice: parseFloat(0.0).toFixed(2),
        Quantityitemnumber: "",
        Quantitydefaultforsale: false,
        Quantitydefaultforreceive: false,
      },
    ]);
  };

  const addNewVariaction = () => {
    const rowsInput = {
      ItemVariationId: 0,
      VariationName: "",
      VariationAttributes: "",
      VariationItemNumber: "",
      VariationID: 0,
      SupplierId: "",
      VariationProductId: "",
    };
    setItemvariations([...Itemvariations, rowsInput]);
  };

  // variation-
  const [keepAttributesForNewVariation, setKeepAttributesForNewVariation] =
    useState();

  useEffect(() => {
    const output = [];
    const tempMap = {};

    attributeValue?.forEach((item) => {
      const key = `${item.Attributeid}`;
      if (!tempMap[key]) {
        tempMap[key] = {
          Quantity: [],
        };
      }
      tempMap[key].Quantity.push({
        ID: item.ID,
        Name: item.Name,
        Attributeid: item.Attributeid,
        Attributevalueid: item.Attributevalueid,
      });
    });

    for (const key in tempMap) {
      output.push(tempMap[key]);
    }

    setKeepAttributesForNewVariation(output);
  }, [attributeValue, autoGenerationFunction]);

  const handleautovariaction = async () => {
    setLoading(true);
    // Convert in to Array Object Of Quantity Values Ids with CommaSeparate

    const QuntityIdCommaSeparate = keepAttributesForNewVariation?.map(
      (obj) => ({
        ...obj,
        Quantity: obj.Quantity?.map((qty) => qty.ID).join(","),
      })
    );

    // Convert in to Array Object Of Quantity Values with CommaSeparate
    const QuntityValueCommasepret = keepAttributesForNewVariation.map(
      (obj) => ({
        ...obj,
        Quantity: obj.Quantity.map((qty) => qty.Name).join(","),
      })
    );

    // Separet From Array Object of Quntity Ids
    const CommaSepateIds = QuntityIdCommaSeparate.map((obj) =>
      obj?.Quantity?.split(",").map(Number)
    );
    // Separet From Array Object of Quntity Values
    const CommaSepateValues = QuntityValueCommasepret.map((obj) =>
      obj?.Quantity?.split(",")
    );

    // Make Variation With Ids with Array Object
    const SeparetIds = Object.values(CommaSepateIds).reduce((acc, curr, i) => {
      if (i === 0) {
        return curr.map((x) => [x]);
      } else {
        const newAcc = [];
        acc.forEach((item) => {
          curr.forEach((val) => {
            newAcc.push([item, val]?.toString());
          });
        });
        return newAcc;
      }
    }, []);

    // Make Variation With Values with Array Object
    const SeparetValues = Object.values(CommaSepateValues).reduce(
      (acc, curr, i) => {
        if (i === 0) {
          return curr.map((x) => [x]);
        } else {
          const newAcc = [];
          acc.forEach((item) => {
            curr.forEach((val) => {
              newAcc.push([item, val]?.toString());
            });
          });
          return newAcc;
        }
      },
      []
    );

    const ItemsNames = formValues.ItemName;
    const VariactionNames = SeparetValues.map((val) => `${ItemsNames}:${val}`);

    // Final Array Object For Sent
    const FinalResult = [];
    for (let i = 0; i < SeparetIds.length; i++) {
      const variationName = VariactionNames[i];
      const variationValue = SeparetIds[i];
      FinalResult.push({
        VariationName: variationName,
        VariationValue: variationValue,
      });
    }

    const jsonobj = {};
    jsonobj.variation = FinalResult;

    let jsonstring = JSON.stringify(jsonobj);

    await axios
      .post(
        `${config.itemsBaseUrl}/items/variationinsert`,
        {
          itemId: paramObject.id,
          XMLVariation: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          const VariactionName = res.data.ResponseData.VariactionName;
          const ItemIdsparams = paramObject.id;

          // Make the Object For Bind the Values
          const ResultObject = VariactionName?.map((obj) => {
            return {
              ItemVariationId: obj.ID,
              VariationName: obj.Name,
              VariationAttributes: obj.VariationAttributes,
              VariationItemNumber: "",
              VariationID: `${ItemIdsparams}#${obj.ID}`,
              SupplierId: "",
              VariationProductId: "",
            };
          });
          setItemvariations(ResultObject);
          toastSuccess(SUCCESS_MESSAGE);
          fetchItemVariation(SUCCESS_MESSAGE);

          axios
            .get(
              `${config.itemsBaseUrl}/items/itemswiseattributeslist?ItemId=${paramObject.id}`,
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: token,
                },
              }
            )
            .then((res) => {
              console.log("itemswiseattributeslist 740", res.data.ResponseData);
              setVariationlist(res.data.ResponseData);
            });
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const addCategory = () => {
    const rowsInput = {
      ID: 0,
      CategoryId: "",
    };

    setCategory([...category, rowsInput]);
  };

  const addSupplier = () => {
    const rowsInput = {
      ID: 0,
      SupplierId: "",
    };
    setSupplier([...supplier, rowsInput]);
  };

  var isCheck = (item) =>
    check.includes(item.ID) ? "checked-item" : "not-checked-item";

  let ParentCategoryOption = [];
  const ItemKits = data.map((u, i) => {
    ParentCategoryOption[i] = { label: u.Name, value: u.ID };
  });

  let Catagories = [];
  const ItemCategories = SecondCategories.map((u, i) => {
    Catagories[i] = { label: u.Name, value: u.ID };
  });

  //Supplies comma separated
  let Supplierlist = [];
  const Supplierlists = suppliers.map((u, i) => {
    // Supplierlist[i] = { label: u.FirstName, value: u.ID };
    Supplierlist[i] = { label: u.Name, value: u.ID };
  });

  // dropdown of manufature
  let Manufacturerdropdown = [];

  // handel for Categories
  const handleChangeforDropdon = (index, event) => {
    let name, values;
    name = "CategoryId";
    values = event.value;

    const cardInput = [...category];
    cardInput[index][name] = values;
    setCategory(cardInput);
  };

  const handleChangeforDropdonsuppliers = (index, event) => {
    let name, values;
    name = "SupplierId";
    values = event.value;

    const cardInput = [...supplier];
    cardInput[index][name] = values;
    setSupplier(cardInput);
  };

  const resetSelect = () => {
    document.getElementById("selected").selectedIndex = 0;
  };

  // Handle Change Attributes-
  const handleAttributeChange = (e) => {
    let name, values;
    if (e.target === undefined) {
      name = "Quantity";
      values = e?.toString();
    }
    setSelectedAttributelablecommadrop((prevState) => ({
      ...prevState,
      [name]: values,
    }));
  };

  // Post Attributes -
  const handleChangeforattribute = async (e) => {
    e.preventDefault();

    if (itemattributes.trim() === "") {
      setNameError("Attribute name is required");
      setAttributeError("");
      return;
    } else if (!SelectedAttributelablecommadrop?.Quantity?.split(",")) {
      setAttributeError("Attribute value is required");
      setNameError("");
      return;
    } else {
      setNameError("");
      setAttributeError("");

      let QuantityValues = SelectedAttributelablecommadrop.Quantity?.toString();
      const AttributeInsertObj = {
        id: 0,
        itemid: paramObject.id,
        attributename: itemattributes,
        attributevalues: QuantityValues,
      };

      setLoading(true);

      try {
        const response = await axios.post(
          `${config.itemsBaseUrl}/items/attributesinsert`,
          AttributeInsertObj,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        );

        if (response.data.ResponseCode === "SUCCESS") {
          resetSelect();
          setAttributedrop(false);
          getDataFunction();
          const newRow = {
            ID: response.data.ResponseData.Attributename[0].ID,
            Name: response.data.ResponseData.Attributename[0].Name,
            Quantity: response.data.ResponseData.Attributevalues,
          };
          toastSuccess(SUCCESS_MESSAGE);
          const updatedItemAttribute = [...itemattribute, newRow];
          setItemAttribute(updatedItemAttribute);
          setItemAttributes("");
          setAttributemodel(false);
          setLoading(false);
          setX(response.data);
          setSelectedAttributelablecommadrop("");
        } else if (
          response.data.ResponseCode === "Sucess" &&
          response.data.ResponseID === -1
        ) {
          toastError("Attribute" + ALREADY_EXIST);
          setItemAttributes("");
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setItemAttributes("");
          setLoading(false);
        }
      } catch (error) {
        console.log(error, "Error in attributesinsert");
      }
    }
  };

  // HandleChanges of Quantity Units
  const handleChangeQuantityUnitsRow = (index, event) => {
    let id, name, values;
    if (event.target.type === "checkbox") {
      name = event.target.name;
      if (event.target.checked === true) {
        values = 1;
      } else {
        values = 0;
      }
    } else {
      name = event.target.name;
      values = event.target.value;
    }
    const rowsInput = [...quantity];
    rowsInput[index][name] = values;
    setQuantity(rowsInput);
  };

  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState();

  // const [mainSupplier, setMainSupplier] = useState();
  // const [selectedSupplier, setSelectedSupplier] = useState();

  //Brands Dropdown-
  const Brandsdropdown = [];
  brands.map((u, i) => {
    Brandsdropdown[i] = { label: u.Name, value: u.ID };
  });

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${config.brandBaseUrl}/brands`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setBrands(res.data.ResponseData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [props, fetchBrandFunction]);

  //deleteVatriation
  const deleteTableRowsVariaction = (index) => {
    const rows = [...Itemvariations];
    rows.splice(index, 1);
    setItemvariations(rows);
  };

  const [selectSupplierIdFlag, setSelectSupplierIdFlag] = useState(false);
  //handlechange of Variation
  const handleChangeVariation = (index, event) => {
    console.log("handleChangeVariation event==>", event);
    console.log("handleChangeVariation event.target==>", event.target);
    let id, name, values;
    if (event.target === undefined) {
      name = "VariationAttributes";
      values = event?.toString();
    } else {
      name = event.target.name;
      values = event.target.value;
    }

    const rowsInput = [...Itemvariations];
    rowsInput[index][name] = values;
    console.log("handleChangeVariation rowsInput[index][name]", index, name);
    console.log("handleChangeVariation rowsInput", rowsInput);

    if (name === "SupplierId" && index === 0 && !selectSupplierIdFlag) {
      for (let i = 0; i < rowsInput.length; i++) {
        rowsInput[i][name] = values;
      }
      setSelectSupplierIdFlag(true);
    }
    console.log("handleChangeVariation 984", name, selectSupplierIdFlag);
    console.log("rowsInput 984", rowsInput);
    setItemvariations(rowsInput);
  };

  console.log("Itemvariations 992", Itemvariations);

  // handlechange For Attirbutes
  const handleChangeAttributesTableRow = (event) => {
    let name, values;
    if (event.target === undefined) {
      name = "AttributesValue";
      values = event?.toString();
    } else {
      name = event.target.name;
      values = event.target.value;
    }
  };

  // deleted Secendory Categories
  const deleteSecondory = (index) => {
    const rows = [...category];
    rows.splice(index, 1);
    setCategory(rows);
  };

  // deleted Suppliers
  const deleteSuppliers = (index) => {
    const rows = [...supplier];
    rows.splice(index, 1);
    setSupplier(rows);
  };

  // close and show model pop
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseAddBrand = () => setShowAddBrand(false);
  const handleShowAddBrand = () => setShowAddBrand(true);

  const handeltagsmodelClose = () => setAttributemodel(false);
  const handeltagsmodelShow = () => setAttributemodel(true);

  const handleAttributsAdd = async (e) => {
    // Check this for Attributessssssssss
    const AttributeInsertObj = {
      id: SelectedAttributeIddrop,
      itemid: paramObject.id,
      attributename: SelectedAttributelabledrop,
      attributevalues: "", //SelectedAttributedrop,
    };

    axios
      .post(
        `${config.itemsBaseUrl}/items/attributesinsert`,
        AttributeInsertObj,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          getDataFunction();
          const newRow = {
            ID: res.data.ResponseData.Attributename[0].ID,
            Name: res.data.ResponseData.Attributename[0].Name || "",
            Quantity: res.data.ResponseData.Attributevalues,
          };
          const cardInput = [...itemattribute, newRow];
          setItemAttribute(cardInput);
          setLoading(false);
          setX(res.data);
          resetSelect();
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "Sucess" &&
          res.data.ResponseID === -1
        ) {
          toastError("Attribute" + ALREADY_EXIST);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error, "Error is in attributesinsert");
      });
  };

  /* AWS FILE UPLOAD */
  const _handleFileChange = (e) => {
    setChangeImagename(true);

    if (vaidation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };

  const vaidation = (name, value) => {
    switch (name) {
      case "Imagename":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type) => {
    setLoading(true);
    uploadAWS(file, AWS_IMAGE_FOLDER_CATEGORIES, (data) => {
      if (data) {
        setImageUrl(data);
        setLoading(false);
      }
    });
  };

  // Model Processs
  // model validations
  const validationSchemaformodel = Yup.object().shape({
    CategoryName: Yup.string().required("Name is required"),
  });

  const [formValuesformodel, setFormValuesformodel] = useState({
    ID: 0,
    CategoryName: "",
    ProductId: "",
    Hidefromgrid: "",
    ParentID: 0,
    Color: "",
    Ecommerce: "",
    Imagename: "",
    CategoryInfopopup: "",
  });
  manufacturedropdwonData.map((u, i) => {
    Manufacturerdropdown[i] = { label: u.Name, value: u.ID };
  });

  const handleDropdownData = (CategorieData) => {
    setLoading(true);
    //for model bind the cetegoires
    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setData(res.data.ResponseData);
        setSecondCategories(res.data.ResponseData);
        if (CategorieData != undefined) {
          let CategorieList = res.data.ResponseData;
          CategorieList.map((selectedCategory) => {
            if (selectedCategory.ID == CategorieData) {
              setselectedCategory({
                label: selectedCategory.Name,
                value: selectedCategory.ID,
              });
            }
          });
        }
      });

    // supplier dropdown
    axios
      .get(`${config.suppliersBaseUrl}/suppliers/dropdownsupplier`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setsuppliers(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.modifiersBaseUrl}/modifiers/selectall`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setModifiers(res.data.ResponseData);
      })
      .catch((err) => {
        // setLoading(false);
      });

    // for bind loactions in model
    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationsData(res.data.ResponseData);
        return res;
      });

    axios
      .get(
        `${config.attributesBaseUrl}/attributes/selectalldropdown?itemid=${paramObject.id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setOptions(res.data.ResponseData);
        return res;
      });
    setLoading(false);
  };

  //locations comma separated
  let itemOption = [];
  locationsData.map((u, i) => {
    itemOption[i] = { label: u.Name, value: u.Id };
  });

  //handlesubmit for categories
  const handleSubmitformodel = async (eventObject) => {
    setLoading(true);
    axios
      .post(
        `${config.categoriesBaseUrl}/categories/upsert`,
        {
          id: eventObject.ID,
          name: eventObject.CategoryName,
          hidefromgrid: selectedItems?.toString(),
          parentid: selectedParentCategory.value
            ? selectedParentCategory.value
            : 0,
          imagename: ImageUrl,
          color: eventObject.Color,
          categoryinfopopup: "",
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          const clearData = {
            ID: 0,
            Name: "",
            Hidefromgrid: false,
            ParentID: 0,
            Color: "",
            Imagename: "",
            CategoryInfopopup: "",
          };
          setFormValuesformodel(clearData);
          handleDropdownData(res.data.ResponseID);
          setImageUrl("");
          setShow(false);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error, "Erro is in Categories Upsert");
      });
  };

  const handleSubmit = async (value) => {
    let Variationdata = Itemvariations?.filter(function (Itemvariations) {
      return Itemvariations.VariationName != "";
    });

    if (Itemvariations?.some((obj) => obj.VariationAttributes === "")) {
      return toastError("Please Fill All Variations");
    }

    const Variationobject = {};
    Variationobject.itemvariationxml = Variationdata;
    let Variationjsonstring = "";
    Variationjsonstring = JSON.stringify(Variationobject);
    let Quantityjsonstring = "";
    if (quantity.length > 0) {
      let data = quantity.filter(function (quantity) {
        return quantity.Name != "";
      });

      const Quantityjsonobj = {};
      Quantityjsonobj.Quantityunitxml = data;
      Quantityjsonstring = JSON.stringify(Quantityjsonobj);
    } else {
      Quantityjsonstring = "";
    }

    let categoryIdArray = category.map((item) => item.CategoryId);
    let supplierIdArray = supplier?.map((item) => item?.SupplierId);
    let Object = {};
    if (paramObject.id === undefined) {
      Object = {
        xmlVariaction: "",
        xmlquantityitems: "",
        id: 0,
        name: value.ItemName,
        itemnumbers: ItemsNumbersArray?.toString(),
        barcodename: value.BarcodeName,
        categoryid: selectedCategory.value || 0,
        loginuserid: loginUserId,
        secondarycategoryIds: categoryIdArray?.toString(),
        modifierIds: "",
        upc: value.UpcName,
        brand: selectedBrand || 0,
        supplierIds: supplierIdArray?.toString(),
        productid: value.ProductId,
        description: value.Description,
        longdescription: value.LongDescription,
        infopopup: value.ImPOP,
        weight: value.Weight > 0 ? value.Weight : 0,
        length: value.DimensionsLength > 0 ? value.DimensionsLength : 0,
        width: value.DimensionsWidth > 0 ? value.DimensionsWidth : 0,
        height: value.DimensionsHeight > 0 ? value.DimensionsHeight : 0,
        weightunit: WeightUnit,
        manufacturerid: selectmanufacturedropdwonData || 0,
        tagsids: selectedtags || "",
        supplierid: primeSupplier?.value || 0,
      };
    } else {
      Object = {
        xmlVariaction: Variationjsonstring,
        xmlquantityitems: Quantityjsonstring,
        id: paramObject.id,
        name: value.ItemName,
        itemnumbers: ItemsNumbersArray?.toString(),
        barcodename: value.BarcodeName,
        categoryid: selectedCategory.value || 0,
        loginuserid: loginUserId,
        secondarycategoryIds: categoryIdArray?.toString(),
        supplierIds: supplierIdArray?.toString(),
        modifierIds: check?.toString(),
        upc: value.UpcName,
        brand: selectedBrand || 0,
        productid: value.ProductId,
        description: value.Description,
        longdescription: value.LongDescription,
        infopopup: value.ImPOP,
        weight: value.Weight > 0 ? value.Weight : 0,
        length: value.DimensionsLength > 0 ? value.DimensionsLength : 0,
        width: value.DimensionsWidth > 0 ? value.DimensionsWidth : 0,
        height: value.DimensionsHeight > 0 ? value.DimensionsHeight : 0,
        weightunit: WeightUnit,
        manufacturerid: selectmanufacturedropdwonData || 0,
        tagsids: selectedtags || "",
        supplierid: primeSupplier.value || 0,
      };
    }

    console.log("Object 1360", Object);
    setLoading(true);
    axios
      .post(`${config.itemsBaseUrl}/items/upsert`, Object, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setLoading(false);
          toastSuccess(SUCCESS_MESSAGE);
          if (paramObject.id === undefined) {
            const ItemID = res.data.ResponseID;
            navigate(`/manage-Items/${ItemID}`);
            setItemFieldshow(false);
          } else {
            if (SubmitEvent == 1) {
              setSubmitEvent(0);
            } else {
              props.nextStep();
              window.scrollTo(0, 0);
            }
          }
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };

  console.log("TagsList, selectedtags 189", TagsList, selectedtags);
  const [newVariation, setNewVariation] = useState([]);
  const getDataFunction = () => {
    if (paramObject.id > 0) {
      setLoading(true);
      setItemFieldshow(false);
      axios
        .get(
          `${config.itemsBaseUrl}/items/iteminfofindbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            setGlobalAttribute(res.data.ResponseData.GlobalAttributeValues);
            setAttributeName(res.data.ResponseData.Attributename);
            setAttributeValue(res.data.ResponseData.Attributevalues);
            setNewVariation(res.data.ResponseData.VariactionName);
            setSelectedBrand(res.data.ResponseData.Items[0].BrandId);
            setPrimeSupplier({
              label: "",
              value: Number(res.data.ResponseData.Items[0].SupplierId),
            });
            handleDropdowns();
            let Dropdown = "SelectAnAttribute";
            setSelectedAttributeIddrop(Dropdown);
            const mappedReceivingItems = res.data.ResponseData.ItemNumbers.map(
              (item) => {
                const mappedItem = {
                  ID: item.ID,
                  ItemNumbers: item.Itemnumber,
                };
                return mappedItem;
              }
            );
            setItem(mappedReceivingItems);
            setSelectedtags(res.data.ResponseData.Items[0].Tagid);
            setselectmanufacturedropdwonData(
              res.data.ResponseData.Items[0].ManufacturerId
            );

            //for Modifires
            const modifierIds = res.data.ResponseData.Modifiers?.map(
              (modifier) => modifier.ModifierId?.toString()
            );
            const newArray = modifierIds?.map((str) => parseInt(str, 10)); // array with commaseparet
            setCheck(newArray);

            let data = res.data.ResponseData.Items[0];
            const itemsdata = {
              ItemName: data.Name,
              BarcodeName: data.Barcodename,
              UpcName: data.Itemnumber,
              ProductId: data.ProductId,
              Description: data.Description,
              LongDescription: data.Longdescription,
              ImPOP: data.InfoPopup,
              Weight: parseFloat(data.Weight).toFixed(2),
              DimensionsLength: parseFloat(data.Length).toFixed(2),
              DimensionsWidth: parseFloat(data.Width).toFixed(2),
              DimensionsHeight: parseFloat(data.Height).toFixed(2),
            };
            setWeightUnit(data.Weightunit);
            setFormValues(itemsdata);

            let AttributesNames = res.data.ResponseData.Attributename;
            let AttributeValues = res.data.ResponseData.Attributevalues;
            const VariactionName = res.data.ResponseData.VariactionName;
            // const VariationValue = res.data.ResponseData.VariactionValues;

            const CombineObject = AttributesNames?.map((obj) => {
              const matchingValues = AttributeValues.filter(
                (valueObj) => valueObj.Attributeid === obj.ID
              );
              const value = matchingValues.map((valueObj) => {
                return { ID: valueObj.ID, Name: valueObj.Name };
              });
              return { ID: obj.ID, Name: obj.Name, Quantity: value };
            });

            const ResultObject = VariactionName.map((obj) => {
              return {
                ItemVariationId: obj.ID || "",
                VariationName: obj.Name || "",
                VariationAttributes: obj.VariationAttributes || "",
                VariationItemNumber: obj?.ItemNumber || "",
                VariationID: `${data.ID}#${obj.ID}` || "",
                SupplierId: obj?.SupplierId || "",
                VariationProductId: obj?.VariationProductId || "",
              };
            });

            console.log("ResultObject 1491", ResultObject);

            setItemAttribute(CombineObject);
            setItemvariations(ResultObject);

            if (res.data.ResponseData.Catagories.length > 0) {
              setCategory(res.data.ResponseData.Catagories);
            }
            if (res.data.ResponseData.Suppliers.length > 0) {
              setSupplier(res.data.ResponseData.Suppliers);
            }
            setQuantity(res.data.ResponseData.itemsserialnumber);
            handleDropdownData(res.data.ResponseData.Items[0].CategoryId);
            axios
              .get(
                `${config.itemsBaseUrl}/items/itemswiseattributeslist?ItemId=${paramObject.id}`,
                {
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: token,
                  },
                }
              )
              .then((res) => {
                setVariationlist(res.data.ResponseData);
              });

            setLoading(false);
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            toastError(ERROR_EXISTS);
            setLoading(false);
          } else {
            toastError(ERROR_MESSAGE);
            setLoading(false);
          }
        });
    } else {
      setItemFieldshow(true);
      handleDropdownData();
    }
  };

  useEffect(() => {
    getDataFunction();
  }, [deleteTableRowsFunction, valueStringFunction]);

  function handleButtonClick() {
    buttonRef.current.click();
  }
  function handleCancelButtonClick() {
    navigate("/items");
  }

  // const selectStyles = {
  //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  // };

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="card">
        <Formik
          {...props}
          initialValues={formValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          <div className="card-header d-flex justify-content-between align-items-center p-1 m-1">
            <h5 className="card-title m-0">
              Item Information
              {/* (Fields in <span className="text-danger">*</span>
              are required) */}
            </h5>
            {ItemFieldshow === false && (
              <div>
                {props.currentStep < props.totalSteps && (
                  <button
                    //   onClick={handleNext}
                    className="btn btn-sm btn-primary btn-md nxtS"
                    type="button"
                    onClick={handleButtonClick}
                  >
                    Next
                  </button>
                )}
              </div>
            )}
          </div>
        </Formik>
        <Formik
          {...props}
          initialValues={formValues}
          // initialValues={{ ItemName: "Hello1", BarcodeName: "Hello2", UpcName: "Hello3" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, touched, handleChange }) => (
            <Form onKeyPress={(e) => e.key === "Enter" && e.preventDefault()}>
              <div className="card-body p-1 m-1">
                {/* Item Name */}
                <div className="row">
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-4">
                        Item Name<span className="text-danger">*</span>
                      </label>
                      <div className="col-md-8">
                        <Field
                          type="text"
                          className={`form-control form-control-sm  ${
                            errors.ItemName ? "is-invalid" : ""
                          }`}
                          name="ItemName"
                          id="ItemName"
                          onChange={handleChange}
                        />
                        <div className="invalid-feedback">
                          {touched.ItemName && errors.ItemName
                            ? errors.ItemName
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Barcode Display Name */}
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-4">
                        Barcode Display Name
                      </label>
                      <div className="col-md-8">
                        <Field
                          type="text"
                          className="form-control form-control-sm"
                          name="BarcodeName"
                          id="BarcodeName"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* UPC and product id */}
                <div className="row mt-2">
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-4">
                        UPC/EAN/ISBN
                      </label>
                      <div className="col-md-8">
                        <Field
                          type="text"
                          name="UpcName"
                          id="UpcName"
                          onChange={handleChange}
                          className="form-control form-control-sm"
                          // disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="row">
                      <label className="col-form-label col-md-4">
                        Product ID
                      </label>
                      <div className="col-md-8">
                        <Field
                          type="text"
                          id="ProductId"
                          name="ProductId"
                          onChange={handleChange}
                          className="form-control form-control-sm"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Additional Item Numbers */}
                <div className="row mt-2">
                  <label className="form-label col-md-2">
                    Additional Item Numbers
                  </label>
                  <div className="col-md-7">
                    <table
                      id="AdditionalItem"
                      name="AdditionalItem"
                      className="table table-responsive p-0"
                    >
                      <thead>
                        <tr>
                          <th style={{ padding: 0 }}>Item Number</th>
                          <th
                            className="text-center"
                            style={{ width: "17.4%" }}
                          >
                            Delete
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {item?.map((data, index) => {
                          const { ID, ItemNumbers } = data;
                          return (
                            <tr key={index}>
                              <td
                                style={{
                                  padding: 0,
                                  width: "80%",
                                }}
                              >
                                <input type="hidden" name="ID" value={ID} />
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  name="ItemNumbers"
                                  value={ItemNumbers}
                                  onChange={(event) =>
                                    handleChangeforitems(index, event)
                                  }
                                />
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <i
                                  className="fa fa-trash text-red fa-2x"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  onClick={() =>
                                    deleteForAdditionalTableRows(index)
                                  }
                                  // disabled
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-md-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-dark"
                      onClick={addItem}
                    >
                      <IoMdAddCircle /> Add UPC Number
                    </button>
                  </div>
                </div>

                {/* Category */}
                <div className="row mt-1 d-flex">
                  <label className="col-md-2" style={{alignSelf: 'center'}}>
                    Category
                    {/* <span className="text-danger">*</span> */}
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={false}
                          onChange={setselectedCategory}
                          options={ParentCategoryOption}
                          placeholder=""
                          styles={selectStyles}
                          value={
                            ParentCategoryOption.find(
                              (option) =>
                                option.value === selectedCategory.value
                            ) || ""
                          }
                          id="Category"
                          name="Category"
                          className="w-100 custom-search-select"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <Link
                      data-bs-toggle="modal"
                      data-backdrop="static"
                      data-keyboard="false"
                      className="btn btn-sm btn-outline-dark"
                      onClick={() => handleShow()}
                      style={{ marginTop: "0.5rem" }}
                    >
                      <IoMdAddCircle /> Add New Category
                    </Link>
                  </div>
                </div>

                {/* Add Categories Model */}
                <Modal show={show} onHide={handleClose} className="modal-lg">
                  <Modal.Header>
                    <Modal.Title>
                      Add Category / Secondary Category{" "}
                    </Modal.Title>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handleClose}
                    >
                      x
                    </button>
                  </Modal.Header>
                  <Formik
                    {...props}
                    initialValues={formValuesformodel}
                    validationSchema={validationSchemaformodel}
                    onSubmit={handleSubmitformodel}
                    // enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                    }) => (
                      <Form
                        onKeyPress={(e) =>
                          e.key === "Enter" && e.preventDefault()
                        }
                      >
                        <Loader loading={loading} />
                        <div className="modal-body">
                          <div className="form-group row">
                            <div className="col-md-3">
                              <label className="form-label">
                                Parent Category
                              </label>
                            </div>
                            <div className="col-md-9 mb-3">
                              <Select
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                hideSelectedOptions={true}
                                isClearable={true}
                                onChange={(e) => {
                                  setselectedParentCategory(e);
                                }}
                                options={ParentCategoryOption}
                                placeholder=""
                                styles={selectStyles}
                                value={selectedParentCategory}
                                id="ParentID"
                                name="ParentID"
                                className="w-100 custom-search-select"
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Category Name
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="text"
                                name="CategoryName"
                                id="CategoryName"
                                className={` custom-search-select ${
                                  errors.CategoryName ? "is-invalid" : ""
                                }`}
                                placeholder="Enter Category Name"
                                value={values.CategoryName}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <div className="invalid-feedback">
                                {touched.CategoryName && errors.CategoryName
                                  ? errors.CategoryName
                                  : ""}
                              </div>
                            </div>
                          </div>

                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Category Color
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="color"
                                name="Color"
                                className={`form-control form-control-sm form-control-color`}
                                value={values.Color}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Category Image
                            </label>
                            <div className="col-md-9 mt-2">
                              <FileInput
                                id="SelectImage"
                                name="SelectImage"
                                value={selectedImage}
                                accept="image/*"
                                handleChange={_handleFileChange}
                              />
                            </div>
                          </div>

                          <div className="col-lg-12 justify-content-right">
                            <button
                              type="submit"
                              className="btn btn-sm btn-primary btn-md me-2"
                            >
                              Submit
                            </button>

                            <button
                              className="btn btn-sm btn-dark btn-md me-1"
                              onClick={handleClose}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Modal>

                {/* Secondary Category */}
                <div className="row d-flex" style={{ marginTop: "-0.6rem" }}>
                  <div className="col-md-9">
                    {category?.map((data, index) => {
                      const { ID, CategoryId } = data;
                      return (
                        <div key={index} className="row d-flex mt-1">
                          <div
                            className="col-md-3"
                            style={{ width: "23%", marginLeft: "4px", alignSelf: 'center'  }}
                          >
                            <label>Secondary Category</label>
                          </div>
                          <div className="col d-flex">
                            <div className="row w-100">
                              <div
                                className="col-md-10 m-0 p-0"
                                style={{ width: "84%" }}
                              >
                                <Select
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={true}
                                  isClearable={true}
                                  onChange={(event) =>
                                    handleChangeforDropdon(index, event)
                                  }
                                  options={Catagories}
                                  placeholder=""
                                  styles={selectStyles}
                                  value={Catagories.find(
                                    (option) =>
                                      option.value ===
                                      category[index].CategoryId
                                  )}
                                  id="CategoryId"
                                  name="CategoryId"
                                  className="custom-search-select"
                                />
                              </div>
                              <div className="col text-center">
                                <i
                                  className="fa fa-trash text-red fa-2x"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  onClick={() => deleteSecondory(index)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="col-md-3" style={{ marginTop: "0.4rem" }}>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-dark text-left"
                      onClick={addCategory}
                      style={{ marginTop: "0.5rem" }}
                    >
                      <IoMdAddCircle /> Add Secondary Category
                    </button>
                  </div>
                </div>

                {/* Supplier */}
                <div className="row d-flex" style={{ marginTop: "-0.8rem" }}>
                  <label style={{ alignSelf: 'center' }} className="col-md-2">Supplier</label>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          options={Supplierlist}
                          value={Supplierlist?.find(
                            (el) => el.value === primeSupplier.value
                          )}
                          placeholder=""
                          styles={selectStyles}
                          id="SupplierId"
                          name="SupplierId"
                          onChange={(event) => handleChangePrimeSupplier(event)}
                          className="custom-search-select"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="col-md-3"></div>
                </div>

                {/* Secondary Supplier */}
                <div className="row d-flex" style={{ marginTop: "-0.3rem" }}>
                  <div className="col-md-9">
                    {supplier?.map((data, index) => {
                      return (
                        <div key={index} className="row d-flex">
                          <div
                            className="col-md-3"
                            style={{ width: "23%", marginLeft: "4px",  alignSelf: 'center' }}
                          >
                            <label>Secondary Supplier</label>
                          </div>
                          <div className="col d-flex">
                            <div className="row w-100">
                              <div
                                className="col-md-10 m-0 p-0"
                                style={{ width: "84%" }}
                              >
                                <Select
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  // hideSelectedOptions={true}
                                  isClearable={true}
                                  onChange={(event) =>
                                    handleChangeforDropdonsuppliers(
                                      index,
                                      event
                                    )
                                  }
                                  options={Supplierlist}
                                  placeholder=""
                                  styles={selectStyles}
                                  value={
                                    Supplierlist
                                      ? Supplierlist.find(
                                          (option) =>
                                            option.value ==
                                            supplier[index]?.SupplierId
                                        )
                                      : []
                                  }
                                  id="SupplierId"
                                  name="SupplierId"
                                  className="custom-search-select"
                                />
                              </div>
                              <div className="col text-center">
                                <i
                                  className="fa fa-trash text-red fa-2x"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  onClick={() => deleteSuppliers(index)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="col-md-3" style={{ marginTop: "0.5rem" }}>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-dark"
                      onClick={addSupplier}
                    >
                      <IoMdAddCircle /> Add Supplier
                    </button>
                  </div>
                </div>

                {/* Brands */}
                <div className="row d-flex" style={{ marginTop: "-0.7rem" }}>
                  <label style={{  alignSelf: 'center' }} className="col-md-2">Brands</label>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          onChange={(e) => setSelectedBrand(e.value)}
                          options={Brandsdropdown}
                          placeholder=""
                          styles={selectStyles}
                          value={Brandsdropdown.find(
                            (option) => option.value === selectedBrand
                          )}
                          id="Category"
                          name="Category"
                          className="w-100 custom-search-select"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="col-md-3" style={{ marginTop: "0.5rem" }}>
                    {checkUserPermission(PERMISSION_ADD) ? (
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#ManageDataModal"
                        data-backdrop="static"
                        data-keyboard="false"
                        className="btn btn-sm btn-outline-dark"
                        onClick={() => handleShowAddBrand()}
                      >
                        <IoMdAddCircle /> Add Brand
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {/* Brands Modal */}
                <Modal
                  show={showAddBrand}
                  onHide={handleCloseAddBrand}
                  className="modal-md"
                >
                  <Modal.Header>
                    <Modal.Title>Manage Brands </Modal.Title>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={() => {
                        handleCloseAddBrand();
                        setError({ ...error, brandError: "" });
                      }}
                    >
                      x
                    </button>
                  </Modal.Header>
                  <Formik {...props}>
                    {({ errors, touched, handleBlur }) => (
                      <>
                        <Loader loading={loading} />
                        <div className="modal-body">
                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Brand Name
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="text"
                                name="CategoryName"
                                id="CategoryName"
                                placeholder="Enter Brand Name"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                  setAddBrand(e.target.value);
                                  e.target.value &&
                                    setError({ ...error, brandError: "" });
                                }}
                              />
                              {error?.brandError && (
                                <div className="error-message">
                                  {error?.brandError}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 justify-content-right">
                            <button
                              disabled={loading == true}
                              type="button"
                              className="btn btn-sm btn-primary btn-md me-2"
                              onClick={handleAddBrand}
                            >
                              Submit
                            </button>

                            <button
                              className="btn btn-sm btn-dark btn-md me-1"
                              onClick={() => {
                                handleCloseAddBrand();
                                setError({ ...error, brandError: "" });
                              }}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </>
                      // </Form>
                    )}
                  </Formik>
                </Modal>

                {/* Tags */}
                <div className="row d-flex" style={{ marginTop: "-0.25rem" }}>
                  <label  style={{  alignSelf: 'center' }}  className="col-md-2">Tags</label>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          isMulti={true}
                          onChange={handleSelectedtags}
                          options={TagsList}
                          placeholder=""
                          // styles={selectStyles}
                          value={TagsList?.filter((obj) =>
                            selectedtags?.includes(obj.value)
                          )}
                          id="Tags"
                          name="Tags"
                          className="w-100 custom-search-select"
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="col-md-3" style={{ marginTop: "0.5rem" }}>
                    {checkUserPermission(PERMISSION_ADD) ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-dark"
                        data-bs-toggle="modal"
                        data-bs-target="#ManageDataModal"
                        onClick={() => handeltagmodelShow()}
                        // disabled
                      >
                        <IoMdAddCircle /> Add Tags
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {/* Tag Modal */}
                <Modal
                  show={showtag}
                  onHide={handleClose}
                  className="modal-md"
                  id="ManageDataModal"
                >
                  <Modal.Header>
                    <Modal.Title>Add Tags</Modal.Title>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={() => {
                        handeltagmodelClose();
                        setError({ ...error, tagError: "" });
                      }}
                    >
                      x
                    </button>
                  </Modal.Header>
                  <Formik
                    {...props}
                    initialValues={formValuesfortagmodel}
                    onSubmit={handleSubmitformodeltags}
                    // enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                    }) => (
                      <Form
                        onKeyPress={(e) =>
                          e.key === "Enter" && e.preventDefault()
                        }
                      >
                        <Loader loading={loading} />
                        <div className="modal-body">
                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Tags
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="text"
                                name="Tags"
                                id="Tags"
                                placeholder="Enter Tag Name"
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              {error?.tagError && (
                                <div className="error-message">
                                  {error?.tagError}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 justify-content-right">
                            <button
                              type="submit"
                              className="btn btn-sm btn-primary btn-md me-2"
                            >
                              Submit
                            </button>
                            <button
                              className="btn btn-sm btn-dark btn-md me-1"
                              onClick={() => {
                                handeltagmodelClose();
                                setError({ ...error, tagError: "" });
                              }}
                              type="button"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Modal>

                {/* Manufacturers */}
                <div className="row d-flex" style={{ marginTop: "-0.25rem" }}>
                  <label  style={{  alignSelf: 'center' }} className="col-md-2">Manufacturers</label>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col react-select-height">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          onChange={(e) =>
                            setselectmanufacturedropdwonData(e.value)
                          }
                          options={Manufacturerdropdown}
                          placeholder=""
                          styles={selectStyles}
                          value={
                            Manufacturerdropdown?.find(
                              (option) =>
                                option?.value === selectmanufacturedropdwonData
                            ) || ""
                          }
                          id="Category"
                          name="Category"
                          className="w-100 custom-search-select"
                          menuPortalTarget={document.body}
                        />
                      </div>
                      <div className="col-md-2"></div>
                    </div>
                  </div>
                  <div className="col-md-3" style={{ marginTop: "0.5rem" }}>
                    {checkUserPermission(PERMISSION_ADD) ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-dark"
                        data-bs-toggle="modal"
                        data-bs-target="#ManageDataModalManufacture"
                        onClick={() => handleManufactureShow()}
                        // disabled
                      >
                        <IoMdAddCircle /> Add Manufacturer
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {/* Manufacturers Modal */}
                <Modal
                  show={showManufacture}
                  onHide={handleManufactureClose}
                  className="modal-md"
                  id="ManageDataModalManufacture"
                >
                  <Modal.Header>
                    <Modal.Title>Add Manufacture</Modal.Title>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={() => {
                        handleManufactureClose();
                        setError({ ...error, manufactureError: "" });
                      }}
                    >
                      x
                    </button>
                  </Modal.Header>
                  <Formik
                    {...props}
                    initialValues={formValuesformenufacturemodel}
                    onSubmit={handleSubmitformodelManufacture}
                    // enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                    }) => (
                      <Form
                        onKeyPress={(e) =>
                          e.key === "Enter" && e.preventDefault()
                        }
                      >
                        <Loader loading={loading} />
                        <div className="modal-body">
                          <div className="form-group row">
                            <label className="col-form-label col-md-3 align-center">
                              Manufacture
                            </label>
                            <div className="col-md-9 mt-2">
                              <Field
                                type="text"
                                name="Manufacture"
                                id="Manufacture"
                                placeholder="Enter Manufacture Name"
                                onBlur={(e) => {
                                  handleBlur(e);
                                  !e &&
                                    setError({
                                      ...error,
                                      manufactureError: "",
                                    });
                                }}
                                onChange={handleChange}
                              />
                              {error?.manufactureError && (
                                <div className="error-message">
                                  {error?.manufactureError}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-lg-12 justify-content-right">
                            <button
                              type="submit"
                              className="btn btn-sm btn-primary btn-md me-2"
                            >
                              Submit
                            </button>
                            <button
                              className="btn btn-sm btn-dark btn-md me-1"
                              onClick={() => {
                                handleManufactureClose();
                                setError({ ...error, manufactureError: "" });
                              }}
                              type="button"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Modal>

                {/* ------------------------------------Item details------------------------------ */}
                <div className="card mt-2" style={{ border: "0px" }}>
                  <h5 className="card-title">Item Details</h5>
                  <div>
                    {/* Weight and Dimension */}
                    <div className="row mt-0 d-flex justify-content-between align-item-center col-11">
                      <div className="col" style={{ marginTop: "-1rem" }}>
                        <div className="row d-flex">
                          <div className="col d-flex">
                            <label className="form-label col-md-3 mt-0">
                              Weight
                            </label>
                            <div
                              className="col-md-6"
                              style={{ marginTop: "-0.4rem" }}
                            >
                              <Field
                                type="number"
                                className="form-control form-control-sm"
                                id="Weight"
                                name="Weight"
                                onChange={handleChange}
                                // disabled
                              />
                            </div>
                          </div>
                          <div className="col d-flex">
                            <label className="form-label col-md-5 mt-0">
                              Weight Unit
                            </label>
                            <div
                              className="col-md-6"
                              style={{ marginTop: "-0.4rem" }}
                            >
                              <select
                                className="form-control form-control-sm"
                                id="WeightUnit"
                                name="WeightUnit"
                                onChange={(e) => setWeightUnit(e.target.value)}
                                value={WeightUnit}
                              >
                                <option value="0">None</option>
                                <option value="1">lb</option>
                                <option value="2">Oz</option>
                                <option value="3">kg</option>
                                <option value="4">g</option>
                                <option value="5">l</option>
                                <option value="6">ml</option>
                                <option value="7">cf</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col d-flex justify-content-between align-item-center"
                        style={{ marginTop: "-1rem" }}
                      >
                        <label className="form-label col-md-3 mt-2">
                          Dimensions
                        </label>
                        <div className="col-md-3">
                          <Field
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Length"
                            id="DimensionsLength"
                            name="DimensionsLength"
                            onChange={handleChange}
                            // disabled
                          />
                        </div>
                        <div className="col-md-3 ml-2">
                          <Field
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Width"
                            id="DimensionsWidth"
                            name="DimensionsWidth"
                            onChange={handleChange}
                            // disabled
                          />
                        </div>
                        <div className="col-md-3 ml-2">
                          <Field
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Height"
                            id="DimensionsHeight"
                            name="DimensionsHeight"
                            onChange={handleChange}
                            // disabled
                          />
                        </div>
                      </div>
                    </div>

                    {/* Descriptions */}
                    <div className="row mt-0 d-flex">
                      <div
                        className="col-md-6"
                        style={{ marginTop: "-0.7rem" }}
                      >
                        <Field
                          name="Description"
                          id="Description"
                          cols="17"
                          rows="5"
                          className="form-control form-control-sm text-area"
                          as="textarea"
                          onChange={handleChange}
                          placeHolder={"Description"}
                        />
                      </div>
                      {/* <div className="col-md-4">
                        <Field
                          name="LongDescription"
                          id="LongDescription"
                          cols="17"
                          rows="5"
                          className="form-control text-area"
                          as="textarea"
                          onChange={handleChange}
                          placeHolder={"Long Description"}
                        />
                      </div> */}
                      <div
                        className="col-md-6"
                        style={{ marginTop: "-0.7rem" }}
                      >
                        <Field
                          name="ImPOP"
                          id="ImPOP"
                          cols="17"
                          rows="5"
                          className="form-control form-control-sm text-area"
                          as="textarea"
                          onChange={handleChange}
                          placeHolder="Information Popup When Adding To Sale"
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-12">
                        {/* <Field
                          name="LongDescription"
                          id="LongDescription"
                          cols="17"
                          rows="5"
                          className="form-control text-area"
                          as="textarea"
                          onChange={handleChange}
                          placeHolder={"Long Description"}
                        /> */}
                        <label className="form-label col-md-2 mt-0">
                          <strong>Long Description</strong>
                        </label>

                        <Field name="LongDescription" id="LongDescription">
                          {({ field }) => (
                            <ReactQuill
                              value={field.value}
                              theme="snow"
                              placeholder="Long Description"
                              style={{ height: "200px" }}
                              onChange={field.onChange("LongDescription")}
                            />
                          )}
                        </Field>

                        {/* <ReactQuill theme="snow" name="LongDescription" id="LongDescription" placeholder="Long Description" style={{height: "200px"}} onChange={handleChange} />; */}
                      </div>
                    </div>
                  </div>
                </div>

                {/* ------------------------------------Item Attributes------------------------------ */}
                {/* Quantity Units */}

                {ItemFieldshow === false && (
                  <>
                    <div className="card mt-5">
                      <h5 className="card-title m-1">Variations</h5>
                      <div className="container-fluid mt-0">
                        <div className="row d-flex">
                          <div className="col-2">
                            <label>Item Attributes</label>
                          </div>
                          {/* -----------working------------ */}
                          <div className="col-7">
                            <div className="input-group">
                              <select
                                id="selected"
                                ref={selectRef}
                                className="form-select mb-3 "
                                onChange={handledrop}
                              >
                                <option value="SelectAnAttribute" values2={1}>
                                  Select An Attribute
                                </option>
                                <option value="NewCustomAttribute" values2={2}>
                                  New Custom Attribute
                                </option>
                                {options.map((option, index) => (
                                  <option
                                    key={index}
                                    value={option.ID}
                                    label={option.Name}
                                    values2={option.AttributevalueId}
                                  >
                                    {option.Name}
                                  </option>
                                ))}
                              </select>
                              {Attributedrop === true ? (
                                <button
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-backdrop="static"
                                  data-keyboard="false"
                                  className="btn btn-outline-dark"
                                  style={{ height: "2.5rem" }}
                                  onClick={() => handeltagsmodelShow()}
                                >
                                  <span>Add</span>
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-outline-dark"
                                  onClick={handleAttributsAdd}
                                  style={{ height: "2.5rem" }}
                                  disabled={
                                    selectRef.current?.value ===
                                    "SelectAnAttribute"
                                  }
                                >
                                  <span>Add Attribute</span>
                                </button>
                              )}
                            </div>
                          </div>
                          <div className="col-3 text-end">
                            <Link
                              to="/attributes"
                              state={paramObject.id}
                              className="btn btn-primary text-right"
                            >
                              Manage Global Attributes
                            </Link>
                          </div>
                        </div>
                        <div>
                          <table className="table pb-2">
                            <thead>
                              {itemattribute.length > 0 ? (
                                <tr>
                                  <th>Name</th>
                                  <th>Values</th>
                                  <th>Delete</th>
                                  <th></th>
                                </tr>
                              ) : (
                                ""
                              )}
                            </thead>
                            <tbody>
                              <AttributesTableRows
                                globalAttribute={globalAttribute}
                                attributeName={attributeName}
                                attributeValue={attributeValue}
                                rowsData={itemattribute}
                                setRowsData={setItemAttribute}
                                deleteTableRows={deleteTableRows}
                                handleChange={handleChangeAttributesTableRow}
                              />
                            </tbody>
                          </table>
                        </div>

                        <div className="row mt-1">
                          <h5 className="card-title col-md-2 fw-bold">
                            Item Variations
                          </h5>
                          <div className="mb-3 ">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th width="10%">Product Id</th>
                                  <th width="20%">Name</th>
                                  <th width="25%">Attributes</th>
                                  <th width="20%">Item Number</th>
                                  <th width="1%">Variation ID</th>
                                  <th width="20%">Supplier</th>
                                  <th width="1%">Delete</th>
                                </tr>
                              </thead>
                              <tbody>
                                <ItemVariactionTableRows
                                  newVariation={newVariation}
                                  rowsData={Itemvariations}
                                  DropdownOptions={Variationlist}
                                  deleteTableRows={deleteTableRowsVariaction}
                                  handleChange={handleChangeVariation}
                                />
                              </tbody>
                            </table>
                          </div>

                          <div
                            className="card-header d-flex justify-content-end align-items-baseline"
                            style={{ marginTop: "-1.5rem" }}
                          >
                            <div className="p-1">
                              <button
                                type="button"
                                className="btn btn-outline-dark"
                                onClick={addNewVariaction}
                              >
                                <IoMdAddCircle /> Add
                              </button>
                            </div>
                            {itemattribute.length > 0 && (
                              <div className="p-1">
                                <button
                                  type="button"
                                  className="btn btn-outline-success"
                                  onClick={handleautovariaction}
                                  disabled={
                                    keepAttributesForNewVariation.length === 0
                                  }
                                >
                                  Auto Generate
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* // Add Attribut Name */}
                    <Modal
                      show={Attributemodel}
                      onHide={handeltagsmodelClose}
                      className="modal-lg"
                      backdrop="static"
                    >
                      <Modal.Header>
                        <Modal.Title>Add Attribute</Modal.Title>
                        <button
                          type="button"
                          className="btn-close"
                          aria-label="Close"
                          onClick={handeltagsmodelClose}
                        >
                          x
                        </button>
                      </Modal.Header>

                      <div className="modal-body">
                        <div className="form-group">
                          <Field
                            type="text"
                            name="Name1"
                            id="Name1"
                            // className="form-control"
                            placeholder="Enter Attribute Name"
                            onChange={(e) => setItemAttributes(e.target.value)}
                            // onKeyDown={handleKeyDown}
                          />
                          {nameError && (
                            <div className="error-message">{nameError}</div>
                          )}
                        </div>
                        <div
                          className="mb-3"
                          // className="form-group"
                        >
                          <TagsInput
                            onChange={handleAttributeChange}
                            placeHolder="Add New Attribute Values"
                            // placeHolder="Add New Attribute Value"
                          />
                          {attributeError && (
                            <div className="error-message">
                              {attributeError}
                            </div>
                          )}
                        </div>
                        <div className="col-lg-12 justify-content-right">
                          <button
                            className="btn btn-primary btn-md me-2"
                            onClick={handleChangeforattribute}
                          >
                            Submit
                          </button>
                          <button
                            className="btn btn-dark btn-md me-1"
                            onClick={handeltagsmodelClose}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </Modal>

                    <div className="text-center" style={{ marginTop: "-1rem" }}>
                      {props.currentStep > 1 && (
                        <button
                          onClick={handleBack}
                          className="btn btn-primary me-3"
                        >
                          Back
                        </button>
                      )}

                      {props.currentStep < props.totalSteps && (
                        <button
                          type="submit"
                          // onClick={handleNext}
                          className="btn btn-sm btn-primary me-3"
                          ref={buttonRef}
                        >
                          Next
                        </button>
                      )}
                      <button
                        onClick={handleSubmitForm}
                        className="btn btn-sm btn-primary btn-md me-3"
                        id="btn_submit"
                        type="submit"
                        disabled={loading}
                      >
                        Save
                      </button>
                      <Link to="/items" className="btn btn-sm btn-secondary btn-md">
                        Cancel
                      </Link>
                    </div>
                  </>
                )}

                {/* Submit Button */}
                {ItemFieldshow === true && (
                  <div className="row">
                    <div className="col-lg-12 mt-4">
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary btn-md me-2"
                      >
                        Next
                      </button>
                      <Link
                        to="/items"
                        className="btn btn-sm btn-secondary btn-md me-1"
                      >
                        Cancel
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </Form>
          )}
        </Formik>

        <ActionButtons {...props} />
      </div>
    </>
  );
};

export default memo(ItemInfo);
